// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__1bRq8","container":"Loading_container__1bOSH","children":"Loading_children__M6qlS"};